import gql from 'graphql-tag';

export const realtimeTokenFieldsFragment = gql`
  fragment AdminRealtimeTokenFields on RealtimeToken {
    token
    expires
    issued
    capability
    clientId
  }
`;